import {
    Box,
    Typography,
    Grid,
    Card
} from '@mui/material'
import { VideoListUrl } from '../../../common/url'
import React, { useRef, useEffect, useState } from 'react'
import axios from 'axios'
import { Carousel } from 'antd'
import { useTranslation } from 'react-i18next'
import { isTablet } from 'react-device-detect'

export const SMInstructionVideo: React.FC = () => {
    
    const { t } = useTranslation()

    const carouselRef = useRef(null)

    const [data, setData] = useState([])

    const next = () => {
        carouselRef.current.next()
        updateTabIndex(1)
    }

    const prev = () => {
        carouselRef.current.prev()
        updateTabIndex(0)
    }
            
    const fetchList = async () => {
        try {
            var url = VideoListUrl + '?sort=sequence:ASC&filters[type][$eq]=Shenma Mobile App'
            const response = await axios.get(url)
            if (response.status === 200) {
                var list = response.data['data']
                setData(chunkArray(list.length > 4 ? list.slice(0, 4) : list, 2))
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        ; (async () => {
            await fetchList()
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const chunkArray = (array, size) => {
        const result = []
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size))
        }
        return result
    }

    const [tabIndex, updateTabIndex] = useState(0)

    const videoItem = (superIndex: number, index: number) => {
        return (
            <Grid item key={index} xs={6}>
                <Box sx={{
                    width: '100%',
                    height: '100%',
                }}>
                    <Card style={{
                        width: '100%',
                        borderRadius: '10px',
                        outline: 'none', 
                        border: 'none',
                        boxShadow: '0px 10px 10px 1px rgba(76, 78, 100, 0.1)',
                    }}>      
                        <iframe 
                        width='100%' 
                        height='350' 
                        src={data[superIndex][index]['attributes']['link'] + '&rel=0'}
                        title='YouTube video player' 
                        frameBorder='0'
                        allow='accelerometer autoplay clipboard-write encrypted-media gyroscope picture-in-picture web-share' 
                        referrerPolicy='strict-origin-when-cross-origin' allowFullScreen>
                        </iframe>                    
                    </Card>
                    
                    <Typography style={{ width: '100%', whiteSpace: 'break-spaces', paddingTop: '10px'}} fontSize={20} fontWeight={600} color={'#141F39'} >
                        {data[superIndex][index]['attributes']['title']}
                    </Typography>
                </Box> 
                
            </Grid>
        )
    }
            
    // ======================= VIEWS
    return (
        data === null || data.length === 0 ? <Box></Box> : <Box
            sx={{
                width: '100%',
                paddingLeft: isTablet ? '40px' : '60px',
                paddingRight: isTablet ? '40px' : '60px',
                paddingTop: '60px', 
                paddingBottom: '60px',
                backgroundColor: '#FFFDF7',
                display: 'flex',
                flexDirection: 'column'
            }}
        >
            <Typography fontSize={32} fontWeight={700} color={'#141F39'} textAlign={'center'}>
                {t('t297')}
            </Typography>

            <Box sx={{
                paddingTop: '40px',
                width: '100%', 

            }}>
                <Carousel dots={false} ref={carouselRef}>
                    {data.map((item, index) => (
                        <Box key={index} sx={{ 
                            width: '100%', 
                            backgroundColor: '#FFFDF7', 
                            paddingLeft: '25px',
                            paddingRight: '25px',
                        }}>
                            <Grid
                                container
                                columnSpacing={5}
                                rowSpacing={10}
                            >
                            {data[index].map((subItem, subIndex) => (
                                videoItem(index, subIndex)
                            ))}
                            </Grid>
                        </Box>
                    ))}
                </Carousel>

            </Box>

            <Box sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: '30px',
            }}>
                <Box key={0} onClick={() => prev()}
                    sx={{
                        backgroundColor: 0 === tabIndex ? '#FFC107' : 'rgba(251, 191, 35, 0.5)',
                        width: '80px',
                        height: '8px',
                        cursor: 'pointer' 
                    }}
                > 
                </Box>
                <Box width={20}></Box>
                <Box key={1} onClick={() => next()}
                    sx={{
                        backgroundColor: 1 === tabIndex ? '#FFC107' : 'rgba(251, 191, 35, 0.5)',
                        width: '80px',
                        height: '8px',
                        cursor: 'pointer' 
                    }}
                >    
                </Box>
            </Box>
        </Box>
    )
}

// ======================= EXPORT
export default SMInstructionVideo
